(function () {
  function getForm(btn) {
    return btn.closest('form');
  }
  function getVariantId(form) {
    var el = form.querySelector('.product-variant-id');
    return el ? el.value : null;
  }
  function getQty(form) {
    var el = form.querySelector('.pdp-buybox__qty-input');
    return el ? parseInt(el.value, 10) || 1 : 1;
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.pdp-buybox__qty-btn');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('.pdp-buybox__qty');
      var input = wrap.querySelector('.pdp-buybox__qty-input');
      var val = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      if (qtyBtn.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (qtyBtn.dataset.action === 'minus') val = Math.max(val - 1, min);
      input.value = val;
      return;
    }

    var actionBtn = e.target.closest('.pdp-buybox__btn');
    if (actionBtn) {
      e.preventDefault();
      if (actionBtn.disabled || actionBtn.classList.contains('is-loading') || actionBtn.classList.contains('is-added')) return;

      var form = getForm(actionBtn);
      if (!form) return;
      var variantId = getVariantId(form);
      var qty = getQty(form);
      if (!variantId) return;

      actionBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          actionBtn.classList.remove('is-loading');

          if (actionBtn.dataset.action === 'buy-now') {
            window.location.href = '/checkout';
            return;
          }

          actionBtn.classList.add('is-added');

          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
              );
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            })
            .catch(function () {});

          setTimeout(function () {
            actionBtn.classList.remove('is-added');
          }, 900);
        })
        .catch(function () {
          actionBtn.classList.remove('is-loading');
        });
    }
  });
})();